import { preload } 		from './modules/mod_preload'
import { navigation } 	from './modules/mod_navigation'
import { slider } 		from './modules/mod_slider'
import { lightbox } 	from './modules/mod_lightbox'
import { scrollToTop } 	from './modules/mod_scrollToTop'
import { aos } 			from './modules/mod_aos'

window.addEventListener('load', () => {
	preload()
	navigation()
	slider()
	lightbox()
	scrollToTop()
	aos()
})
